var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checkEvent.success && _vm.checkAuth.isAuthenticated)?_c('v-container',{attrs:{"fluid":""}},[_c('Header'),_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1)],1):(_vm.checkEvent.success == false)?_c('v-container',{attrs:{"fluid":""}},[_c('EventNotFound')],1):_c('v-container',{attrs:{"fluid":""}},[_c('Loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }